import * as React from 'react';

function useOnClickOutside(ref, handler) {
  const onClick = React.useCallback((event) => {
    if (!ref.current || ref.current.contains(event.target)) {
      return;
    }

    handler(event);
  }, [handler, ref]);

  // Capture phase: a toggle elsewhere that stops its click's propagation (e.g. another row's
  // dropdown) must still count as a click outside this one.
  React.useEffect(() => {
    document.addEventListener('click', onClick, true);

    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, [onClick]);
}

export default useOnClickOutside;